module.exports = __webpack_public_path__ + "static/media/twitterStatic.61a39cad.svg";